import { styled } from 'stitches.config'

export const CircleRoot = styled('div', {
  size: '$5',
  borderRadius: '$round',
  borderStyle: 'solid',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  variants: {
    variant: {
      primary: {
        backgroundColor: '$secondary-100',
        borderColor: '$primary-500',
        color: '$primary-800',
      },
      secondary: {
        backgroundColor: '$secondary-100',
        borderColor: '$secondary-600',
        color: '$primary-800',
      },
    },
    border: {
      regular: {
        borderWidth: '1px',
      },
      thick: {
        borderWidth: '3px',
      },
    },
  },

  defaultVariants: {
    border: 'regular',
  },
})
